import { createMemo, For, type JSX } from 'solid-js'

import Css from './charts.module.scss'

export type CategoryBar = {
    category: string
    count: number
    color: string
    onSelect: () => Promise<void>
}

/**
 * A distribuicao por faixa de status.
 *
 * Cada barra E um conjunto de colaboradores - os que tem a metrica escolhida
 * naquela faixa -, e clicar nela abre a lista com o filtro ja aplicado. Barra
 * vazia nao clica: nao ha lista a mostrar.
 */
export function CategoryBars(props: { bars: CategoryBar[]; height?: number }): JSX.Element {
    const max = createMemo(() => Math.max(1, ...props.bars.map((bar) => bar.count)))
    const height = () => props.height ?? 300

    return (
        <div class={Css.bars}>
            <div class={Css.barsFloor} style={{ height: `${height()}px` }}>
                <For each={props.bars}>
                    {(bar) => (
                        <button
                            type="button"
                            disabled={bar.count === 0}
                            onClick={() => void bar.onSelect()}
                            title={`${bar.count} colaborador${bar.count === 1 ? '' : 'es'}`}
                            class={Css.column}
                        >
                            <span class={Css.columnValue}>{bar.count}</span>
                            <span
                                class={Css.bar}
                                style={{
                                    height: `${Math.max(bar.count === 0 ? 0 : 3, (bar.count / max()) * 100)}%`,
                                    'background-color': bar.color
                                }}
                            />
                        </button>
                    )}
                </For>
            </div>

            <div class={Css.legend}>
                <For each={props.bars}>
                    {(bar) => (
                        <span class={Css.legendItem}>
                            <span class={Css.legendSwatch} style={{ 'background-color': bar.color }} />
                            <span class={Css.legendName}>{bar.category}</span>
                        </span>
                    )}
                </For>
            </div>
        </div>
    )
}
